import { render } from "./home.vue?vue&type=template&id=50e12f66&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=50e12f66&scoped=true&lang=css"

import exportComponent from "/Users/asial/projects/fruit-freshness-classification/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e12f66"]])

export default __exports__